export default "__VITE_ASSET__CI3z7A0p__"